import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import RegistrationForm from "./components/register/RegistrationForm";
import Login from "./components/login/Login";
import Dashboard from "./components/dashboard/Dashboard";
import Meeting from "./components/meeting/Meeting";
import LandingPage from "./components/landing-page/LandingPage";
import { getUserKey } from "./utils/auth";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { UserProvider } from "./context/UserContext";

// Auth Guard Component
function ProtectedRoute({ children }) {
    const user = getUserKey();
    if (!user) {
        return <Navigate to="/login" replace />;
    }
    return children;
}

// Redirect if already logged in Component
function PublicOnlyRoute({ children }) {
    const user = getUserKey();
    if (user) {
        return <Navigate to="/dashboard" replace />;
    }
    return children;
}


// Scroll to top component
function ScrollToTop() {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return null;
}

function App() {

    return (
        <UserProvider>
            <>
                <ScrollToTop />
                <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" />
                {/* Skip to main content link for screen readers */}
                <a
                    href="#main-content"
                    className="skip-link"
                    style={{
                        position: "absolute",
                        top: "-40px",
                        left: "6px",
                        backgroundColor: "#2563eb",
                        color: "white",
                        padding: "8px 16px",
                        textDecoration: "none",
                        borderRadius: "4px",
                        fontSize: "14px",
                        fontWeight: "600",
                        zIndex: 1000,
                        transition: "top 0.3s",
                    }}
                    onFocus={(e) => {
                        e.target.style.top = "6px";
                    }}
                    onBlur={(e) => {
                        e.target.style.top = "-40px";
                    }}
                >
                    Skip to main content
                </a>

                <Routes>
                    {/* Routes without standard Header/Footer */}
                    <Route
                        path="/login"
                        element={
                            <PublicOnlyRoute>
                                <Login />
                            </PublicOnlyRoute>
                        }
                    />
                    <Route
                        path="/dashboard"
                        element={
                            <ProtectedRoute>
                                <Dashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/meeting"
                        element={
                            <ProtectedRoute>
                                <Meeting />
                            </ProtectedRoute>
                        }
                    />

                    {/* Routes with standard Header/Footer */}
                    <Route
                        path="*"
                        element={
                            <>
                                <Header />
                                <main id="main-content" role="main" tabIndex="-1">
                                    <Routes>
                                        <Route
                                            path="/"
                                            element={<LandingPage />}
                                        />
                                        <Route path="/reg" element={<Navigate to="/" replace />} />
                                        <Route
                                            path="/registration"
                                            element={<RegistrationForm />}
                                        />
                                    </Routes>
                                </main>
                                <Footer />
                            </>
                        }
                    />
                </Routes>
            </>
        </UserProvider>
    );
}

export default App;
